"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
require("./input-field.scss");
var TextFiledComponent = function (_a) {
    var type = _a.type, name = _a.name, placeholder = _a.placeholder, className = _a.className, value = _a.value, onChange = _a.onChange, minLength = _a.minLength, style = _a.style, label = _a.label, error = _a.error, required = _a.required, onClick = _a.onClick, isRequered = _a.isRequered, defaultVal = _a.defaultVal, isDisabled = _a.isDisabled, FormHelperTextProps = _a.FormHelperTextProps, onBlur = _a.onBlur, maxLength = _a.maxLength, onKeyPress = _a.onKeyPress, readOnly = _a.readOnly, onFocus = _a.onFocus, autoComplete = _a.autoComplete, id = _a.id, compact = _a.compact, statusChip = _a.statusChip;
    var _b = React.useState(''), textFieldval = _b[0], setTextFieldVal = _b[1];
    var onChangeHandler = function (e) {
        setTextFieldVal(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    };
    var getChipStyle = function (status) {
        var styles = {
            'Active': { background: '#EAF3DE', color: '#27500A' },
            'Draft': { background: '#E6F1FB', color: '#0C447C' },
            'Exited': { background: '#F1EFE8', color: '#444441' },
            'In-Active': { background: '#FCEBEB', color: '#791F1F' },
            'Pending for approval': { background: '#FAEEDA', color: '#633806' },
            'Approved': { background: '#EAF3DE', color: '#27500A' },
            'Rejected': { background: '#FCEBEB', color: '#791F1F' },
        };
        return styles[status] || { background: '#F1EFE8', color: '#444441' };
    };
    React.useEffect(function () {
        setTextFieldVal(value);
    }, [value]);
    var params = [];
    if (value) {
        params.push({ label: value });
    }
    return (React.createElement("div", { className: [
            required ? 'input-wrapper validate-filed' : 'input-wrapper',
            compact ? 'compact-field' : '',
        ]
            .filter(Boolean)
            .join(' ') },
        React.createElement(material_1.TextField, { type: type, key: name, name: name, className: className, value: textFieldval, label: label, variant: "filled", disabled: isDisabled, onChange: onChangeHandler, onBlur: onBlur, error: !!error, onKeyPress: onKeyPress, autoComplete: "off", helperText: error ? error : null, style: style, fullWidth: true, inputProps: {
                readOnly: readOnly,
                minLength: minLength,
                maxLength: maxLength || 100,
            }, InputProps: statusChip
                ? {
                    endAdornment: (React.createElement(material_1.Chip, { label: statusChip, size: "small", style: __assign(__assign({}, getChipStyle(statusChip)), { fontSize: '11px', fontWeight: 500, height: '22px', borderRadius: '99px', marginRight: '4px' }) })),
                }
                : undefined, onFocus: onFocus, defaultValue: defaultVal, id: id })));
};
exports.default = TextFiledComponent;
